import styled, { createGlobalStyle } from 'styled-components';
import { Button, Modal } from 'antd';
import * as palette from '../../styles/variables';

export const Container = styled.div`
  height: 100%;
  position: relative;
  padding-left: 20px;
  width: 100%;
  display: flex;
  justify-content: center;
  background-color: #f5f5f5;
`;

export const LoaderContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const SettingpageContainer = styled.div`
  max-width: 1400px;
  width: 100%;
  margin-left: 4%;
  height: 100%;
  display: flex;
  align-items: center;
  background: #f5f5f5;
  padding: 15px 0px;
`;

export const UserContainer = styled.div`
  max-width: 1400px;
  width: 100%;
`;

export const DetailWrapper = styled.div`
  width: 100%;
  height: 100%;
  padding-left: 4rem;
  @media (max-width: 1024px) {
    padding-left: 1rem;
  }
  display: flex;
  flex-direction: column;
  overflow: hidden;
  ::-webkit-scrollbar {
    display: none;
  }
`;

export const DetailHeadingCover = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 20px 0;
  position: sticky;
  top: 0;
  background: #f5f5f5;
  z-index: 10;
  margin-bottom: 20px;
  h5 {
    font-size: 50px;
    font-weight: 400;
    text-align: center;
    font-family: ${palette.FONT_FAMILY_TEMPLATE};
    margin: 0;
    @media only screen and (min-width: 2560px) {
      font-size: 95px;
      margin-top: 70px;
    }
    @media only screen and (min-width: 1460px) {
      font-size: 55px;
    }
    @media only screen and (max-width: 728px) {
      font-size: 35px;
    }
  }
  p {
    font-size: 10px;
    text-transform: uppercase;
    font-weight: 400;
    color: #000;
    font-family: 'Roboto', sans-serif;
    text-align: center;
    margin: 10px 0 0 0;
    @media only screen and (min-width: 2560px) {
      font-size: 20px;
      margin-top: 70px;
    }
    @media only screen and (min-width: 1460px) {
      font-size: 13px;
    }
  }
`;

export const ContractsScrollContainer = styled.div`
  flex: 1;
  overflow-y: auto;
  padding-bottom: 20px;
  ::-webkit-scrollbar {
    display: none;
  }
`;

export const ContractsGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  width: 100%;
  padding: 0 4rem;
  @media (max-width: 1024px) {
    padding: 0 1rem;
  }
`;

export const ContractCard = styled.div`
  width: 280px;
  height: 200px;
  background: #ffffff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  padding: 20px;
  display: flex;
  flex-direction: column;
  position: relative;
  cursor: pointer;
  border: ${props => props.isCreateCard ? '2px dashed #d9d9d9' : 'none'};
  transition: box-shadow 0.3s;
  &:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  }
`;

export const CreateCard = styled(ContractCard)`
  align-items: center;
  justify-content: center;
  text-align: center;
  .create-icon {
    font-size: 48px;
    color: #000;
    margin-bottom: 10px;
  }
  .create-title {
    font-size: 16px;
    font-weight: 600;
    color: #333;
    margin-bottom: 5px;
  }
  .create-subtitle {
    font-size: 12px;
    color: #999;
  }
`;

export const ContractIcon = styled.div`
  width: 40px;
  height: 40px;
  background: #7c3aed;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 15px;
`;

export const ContractTitleWrapper = styled.div`
  min-height: 48px;
  max-height: 48px;
  display: flex;
  align-items: flex-start;
  margin-bottom: 10px;
`;

export const ContractTitle = styled.div`
  font-size: 16px;
  font-weight: 600;
  color: #333;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 24px;
  word-break: break-word;
`;

export const ContractDivider = styled.div`
  width: 100%;
  height: 1px;
  background: #e8e8e8;
  margin: 10px 0;
  flex-shrink: 0;
`;

export const ContractDate = styled.div`
  font-size: 12px;
  color: #999;
  margin-top: auto;
  flex-shrink: 0;
`;

export const ContractActions = styled.div`
  position: absolute;
  top: 15px;
  right: 15px;
  display: flex;
  gap: 10px;
  .anticon {
    font-size: 16px;
    color: #666;
    cursor: pointer;
    &:hover {
      color: #000;
    }
  }
  .anticon-delete {
    color: #ff4d4f;
    &:hover {
      color: #ff7875;
    }
  }
`;

// Editor Styles
export const EditorContainer = styled.div`
  display: flex;
  height: 100vh;
  background: #f5f5f5;
  margin-left: 5%;
  width: 95%;
`;

export const LeftPanel = styled.div`
  width: 40%;
  background: #ffffff;
  padding: 30px;
  overflow-y: auto;
  border-right: 1px solid #e8e8e8;
`;

export const RightPanel = styled.div`
  width: 60%;
  background: #ffffff;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  position: relative;
`;

export const BackLink = styled.div`
  display: flex;
  align-items: center;
  color: #666;
  cursor: pointer;
  margin-bottom: 20px;
  font-size: 14px;
  &:hover {
    color: #000;
  }
  .anticon {
    margin-right: 8px;
  }
`;

export const EditorTitle = styled.h1`
  font-size: 28px;
  font-weight: 600;
  margin: 0 0 10px 0;
  color: #333;
`;

export const EditorDescription = styled.p`
  font-size: 14px;
  color: #666;
  margin-bottom: 30px;
  line-height: 1.6;
`;

export const FormField = styled.div`
  margin-bottom: 20px;
  label {
    display: block;
    font-size: 14px;
    font-weight: 500;
    color: #333;
    margin-bottom: 8px;
  }
  .ant-input,
  .ant-input-affix-wrapper {
    border-radius: 4px;
  }
`;

export const TipCard = styled.div`
  background: #f9f9f9;
  border-left: 3px solid #7c3aed;
  padding: 15px;
  border-radius: 4px;
  margin-top: 20px;
  h4 {
    font-size: 14px;
    font-weight: 600;
    margin: 0 0 8px 0;
    color: #333;
  }
  p {
    font-size: 13px;
    color: #666;
    margin: 0;
    line-height: 1.5;
    .entity-attribute {
      color: #7c3aed;
      font-weight: 500;
    }
  }
`;

export const TabsContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  .ant-tabs {
    height: 100%;
    display: flex;
    flex-direction: column;
  }
  .ant-tabs-content {
    flex: 1;
    overflow: auto;
  }
  .ant-tabs-tab {
    font-size: 14px;
    font-weight: 500;
  }
  .ant-tabs-tab-active {
    color: #7c3aed !important;
    font-weight: 600;
  }
  .ant-tabs-ink-bar {
    background-color: #7c3aed !important;
  }
  .ant-tabs-tab:hover {
    color: #7c3aed !important;
  }
`;

export const TabHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 30px;
  border-bottom: 1px solid #e8e8e8;
`;

export const ImportButton = styled(Button)`
  background: #7c3aed;
  border-color: #7c3aed;
  color: #fff;
  font-weight: 500;
  height: 36px;
  &:hover,
  &:focus {
    background: #6d28d9;
    border-color: #6d28d9;
    color: #fff;
  }
`;

export const TabContent = styled.div`
  padding: 20px 30px;
  height: 100%;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
`;

export const TabContentWithSave = styled.div`
  padding: 20px 30px;
  height: 100%;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  padding-bottom: 100px;
`;

export const JsonEditorWrapper = styled.div`
  border: 1px solid #e8e8e8;
  border-radius: 4px;
  background: #fafafa;
  overflow: hidden;

  .monaco-editor {
    border-radius: 4px;
  }

  .monaco-editor .margin {
    background-color: #fafafa;
  }
`;

export const JsonValidationStatus = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 10px;
  font-size: 14px;
  color: ${props => props.isValid ? '#52c41a' : '#ff4d4f'};
  .anticon {
    font-size: 16px;
  }
`;

export const JsonEditorContainer = styled.div`
  position: relative;
  width: 100%;
`;

export const EmptyState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 400px;
  color: #999;
  text-align: center;
  h3 {
    font-size: 18px;
    font-weight: 600;
    color: #333;
    margin-bottom: 10px;
  }
  p {
    font-size: 14px;
    color: #666;
  }
`;

export const XPathMappingTable = styled.div`
  width: 100%;
  margin-top: 20px;
`;

export const XPathMappingTableHeader = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 50px;
  gap: 15px;
  padding: 12px 15px;
  background: #f5f5f5;
  border: 1px solid #e8e8e8;
  border-bottom: none;
  font-weight: 600;
  font-size: 14px;
  color: #333;
  text-transform: uppercase;
`;

export const XPathTableHeader = XPathMappingTableHeader;

export const XPathTableBody = styled.div`
  display: flex;
  flex-direction: column;
  max-height: 450px;
  overflow-y: auto;
`;

export const XPathMappingRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 50px;
  gap: 15px;
  align-items: flex-start;
  padding: 15px;
  border: 1px solid #e8e8e8;
  border-top: none;
  background: #ffffff;
  &:last-child {
    border-bottom: 1px solid #e8e8e8;
  }
  .ant-input {
    width: 100%;
  }
  .anticon-delete {
    color: #ff4d4f;
    cursor: pointer;
    font-size: 18px;
    text-align: center;
    &:hover {
      color: #ff7875;
    }
  }
`;

/** Raising z-index so Monaco suggest/hover widgets attached to document.body sit above antd modals and VariableMentionPopup */
export const MonacoOverflowGlobalStyle = createGlobalStyle`
  .monaco-editor .overflowingContentWidgets,
  .monaco-editor-overflowing-widgets {
    z-index: 10001 !important;
  }
`;

export const XPathEditorCell = styled.div`
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  background: #fff;
  overflow: hidden;
  min-height: 32px;
  min-width: 0;
  display: flex;
  flex-direction: column;
`;

export const AddMappingButton = styled(Button)`
  margin-top: 20px;
  margin-bottom: 0;
  border-style: solid;
  border-color: #ffc53d;
  background: #ffc53d;
  color: #000;
  width: auto;
  height: 36px;
  font-weight: 500;
  &:hover,
  &:focus {
    background: #ffd666;
    border-color: #ffd666;
    color: #000;
  }
`;

export const BottomBar = styled.div`
  position: fixed;
  bottom: 0;
  left: 5%;
  right: 0;
  height: 60px;
  background: #ffffff;
  border-top: 1px solid #e8e8e8;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 30px;
  z-index: 100;
  box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.1);
`;


export const SaveButton = styled(Button)`
  background: #7c3aed;
  border-color: #7c3aed;
  color: #fff;
  font-weight: 500;
  height: 40px;
  padding: 0 24px;
  &:hover,
  &:focus {
    background: #6d28d9;
    border-color: #6d28d9;
    color: #fff;
  }
`;

export const HelpButton = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: #333;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 18px;
  font-weight: bold;
  &:hover {
    background: #000;
  }
`;

export const DeleteModal = styled(Modal)`
  .ant-modal-content {
    .ant-modal-header {
      background-color: #fff;
      h4 {
        color: #333;
      }
    }
  }
`;

